import {Component, OnInit} from '@angular/core';
import {
    AnalyticsCommonDataItem, AnalyticsDashboardService, AnalyticsData,
    TimeInterval
} from "../../services/analytics-dashboard.service";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    realTimeSubscription;
    intervals: any;
    selectedInterval: TimeInterval;
    data: AnalyticsData;
    commonData: Array<{metricName: string, data: AnalyticsCommonDataItem}>;

    constructor(private analyticsService: AnalyticsDashboardService) {
    }


    ngOnInit() {
        this.selectedInterval = TimeInterval.Hour;
        this.intervals = TimeInterval;
        this.analyticsService.loadAggregatedStats(this.selectedInterval).subscribe((data: AnalyticsData) => {
            this.data = data;
            this.commonData = Object.keys(this.data.common).map((metric) => ({metricName: metric, data: this.data.common[metric] as AnalyticsCommonDataItem}));
        })


    }

    selectInterval(event) {
        this.selectedInterval = parseInt(event.target.dataset['interval']);
        if(this.selectedInterval as TimeInterval === TimeInterval.RealTime){
            if(!this.realTimeSubscription) {
                this.realTimeSubscription = setInterval(() => {
                    this.analyticsService.loadAggregatedStats(this.selectedInterval).subscribe((data: AnalyticsData) => {
                        this.data = data;
                        this.commonData = Object.keys(this.data.common).map((metric) => ({
                            metricName: metric,
                            data: this.data.common[metric] as AnalyticsCommonDataItem
                        }));
                    });
                }, 1000);
            }
        }else {
            if(this.realTimeSubscription){
                clearInterval(this.realTimeSubscription);
                this.realTimeSubscription = null;
            }
            this.analyticsService.loadAggregatedStats(this.selectedInterval).subscribe((data: AnalyticsData) => {
                this.data = data;
                this.commonData = Object.keys(this.data.common).map((metric) => ({
                    metricName: metric,
                    data: this.data.common[metric] as AnalyticsCommonDataItem
                }));
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.component.ts